var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("CollapsableListItem", {
    staticClass: "item position-relative",
    class: { current: _vm.isCurrent },
    scopedSlots: _vm._u(
      [
        {
          key: "controls",
          fn: function () {
            return [
              _c("div", { staticClass: "d-flex" }, [
                _c(
                  "div",
                  { staticClass: "mr-auto d-flex gap-1 align-items-center" },
                  [_vm._t("badges")],
                  2
                ),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "dropdown" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-invisible btn-sm",
                        attrs: {
                          type: "button",
                          "data-toggle": "dropdown",
                          "aria-expanded": "false",
                        },
                      },
                      [_c("i", { staticClass: "fas fa-ellipsis-v" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "dropdown-menu" },
                      [
                        _vm._t("menu"),
                        _vm._v(" "),
                        _vm.isMenuEmpty
                          ? _c(
                              "div",
                              { staticClass: "text-muted text-center" },
                              [_vm._v("Empty")]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "header",
          fn: function () {
            return [_vm._t("header")]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [_vm._t("body")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }